import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IBlockchainBase, ICompanyBase } from '@/types'
import { OverviewItem } from '@/components/molecules/OverviewItem'
import { getFormattedAmount } from '@/utils'
import WebsiteSvg from '@/public/images/common/website.svg'
import ChainSvg from '@/public/images/common/chain.svg'
import StageSvg from '@/public/images/common/stage.svg'
import TotalFundingSvg from '@/public/images/common/total_funding.svg'
import EmployeeSvg from '@/public/images/common/employee.svg'
import LocationSvg from '@/public/images/common/location.svg'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
}

export const CompanyOverviewItemList: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['p'])

  const uniqueBlockchains = company?.blockchains.reduce((a: IBlockchainBase[], v) => {
    if (!a.some((e: IBlockchainBase) => e.slug === v.slug)) {
      a.push(v)
    }
    return a
  }, [])

  return (
    <div className={styles.container}>
      {company?.url && <OverviewItem logo={<WebsiteSvg />} title='Website' text={company?.url} isLink />}
      {uniqueBlockchains.length > 0 && (
        <OverviewItem
          logo={<ChainSvg />}
          title='Chain'
          text={uniqueBlockchains
            .map((blockchain) => {
              return blockchain.name
            })
            .join(', ')}
        />
      )}
      {!company?.isVc && (
        <>
          {company?.round && <OverviewItem logo={<StageSvg />} title={t('ステージ')} text={t(company?.round.name)} />}
          <OverviewItem
            logo={<TotalFundingSvg />}
            title={t('合計資金調達額')}
            text={getFormattedAmount(Number(company?.totalFundingAmount), company?.currencyUnit)}
          />
        </>
      )}
      <OverviewItem logo={<EmployeeSvg />} title={t('従業員数')} text={t(company?.companySize)} />
      {company?.locations.length > 0 && (
        <OverviewItem
          logo={<LocationSvg />}
          title={t('所在地')}
          text={company?.locations
            .map((location) => {
              return location.name
            })
            .join(', ')}
        />
      )}
    </div>
  )
}
